import { routerReducer as router } from 'react-router-redux';
import { reducer as app } from './modules/app';
import { reducer as jobs } from './modules/jobs';
import { reducer as signup } from './modules/signup';
import { reducer as locations } from './modules/locations';
import { reducer as officers } from './modules/officers';
import { reducer as payments } from './modules/payments';
import { reducer as coordinators } from './modules/coordinators';
import { reducer as reports } from './modules/reports';
import { reducer as quickpay } from './modules/quickpay';

/* ------------- Assemble Reducers object ------------- */
export default {
	router,
	app,
	jobs,
	signup,
	locations,
	officers,
	payments,
	coordinators,
	reports,
	quickpay,
};
